import { Footer, Movies, Navbar } from "../components";
import AdsBannerTop from "../components/AdsBannerTop";

const MoviesPage = () => {
  return (
    <section>
      <Navbar />
      <AdsBannerTop />
      <Movies />
      <Footer />
    </section>
  );
};

export default MoviesPage;
